import axiosInstance from "@/services/axiosInterceptor";

export async function getGuideProfile(guideId) {
  try {
    const response = await axiosInstance.get(
      guideId ? `guides/profile/${guideId}` : `guides/profile`
    );
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
